/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import add from 'date-fns/add';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import '../profile/reports/Reports.scss';
import { formatDate, getNewDate } from '../../shared/helper-utils/appUtils';
import { API_DATE_FORMAT, TODAY_DATE } from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import { getBookingsApi } from '../../api/flightApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';

function BulkInvoiceDownload() {
  const [fromDate, setFromDate] = useState(getNewDate(TODAY_DATE));
  const [toDate, setToDate] = useState(
    add(getNewDate(TODAY_DATE), { days: 1 }),
  );
  const [isLoading, setIsLoading] = useState(false);
  const [bookingList, setBookingsList] = useState([]);
  const [selectedTxList, setSelectedTxList] = useState([]);

  const handleGetReports = async () => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    const list = await getBookingsApi(
      formatDate(getNewDate(fromDate), API_DATE_FORMAT),
      formatDate(getNewDate(toDate), API_DATE_FORMAT),
      agentId,
    );
    list.sort((a, b) => {
      const [aDate, aTime] = a.FlightRecord?.BookingDate?.split(' ');
      const [bDate, bTime] = b.FlightRecord?.BookingDate?.split(' ');
      if (aDate > bDate) return -1;
      if (aDate < bDate) return 1;
      const [aHours, aMinutes, aSeconds, aMilliseconds] = aTime?.split(/[:.]/);
      const [bHours, bMinutes, bSeconds, bMilliseconds] = bTime?.split(/[:.]/);
      const aTimeValue =
        parseInt(aHours, 10) * 3600000 +
        parseInt(aMinutes, 10) * 60000 +
        parseInt(aSeconds, 10) * 1000 +
        parseInt(aMilliseconds, 10);
      const bTimeValue =
        parseInt(bHours, 10) * 3600000 +
        parseInt(bMinutes, 10) * 60000 +
        parseInt(bSeconds, 10) * 1000 +
        parseInt(bMilliseconds, 10);
      return bTimeValue - aTimeValue;
    });
    list.forEach((ele) => {
      const { SectorRecord } = ele.SectorRecords;
      ele.SectorRecords.SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      ele.SectorRecords.SectorRecord = ele.SectorRecords.SectorRecord.sort(
        (a, b) => a.TripNumber - b.TripNumber,
      );
    });
    setBookingsList(list);
    setIsLoading(false);
  };

  const handleSelection = (tx) => {
    setSelectedTxList((prevItems) => {
      if (prevItems.some((selectedItem) => selectedItem === tx)) {
        return prevItems.filter((selectedItem) => selectedItem !== tx);
      }
      return [...prevItems, tx];
    });
  };

  return (
    <div className="reports-page py-4">
      <AppLoading isLoading={isLoading} />
      <div className="reports-page_container">
        <div className="reports-page_header">Bulk Invoice</div>
        <div className="reports-page_content p-3">
          <Row className="spacing-8">
            <Col xs={12} lg={3} md={3} sm={6}>
              <AppDatePicker
                selectedDate={fromDate}
                type="date"
                name="fromDate"
                placeholder=""
                label="From Date"
                customClassName="position-relative"
                labelClassName="landing-datepicker-label"
                onChange={(date) => setFromDate(date)}
              />
            </Col>
            <Col xs={12} lg={3} md={3} sm={6}>
              <AppDatePicker
                selectedDate={toDate}
                type="date"
                name="toDate"
                placeholder=""
                label="To Date"
                labelClassName="landing-datepicker-label"
                customClassName="position-relative"
                onChange={(date) => setToDate(date)}
              />
            </Col>

            <Col
              xs={6}
              lg={2}
              md={2}
              sm={6}
              className="d-flex align-items-center"
            >
              <AppButton
                variant="outlined"
                btnText="Go"
                onClick={handleGetReports}
              />
            </Col>
            <Col
              xs={6}
              lg={2}
              md={2}
              sm={6}
              className="d-flex align-items-center"
            >
              <AppButton
                variant="primary"
                btnText="Download"
                disabled={selectedTxList.length === 0}
                onClick={handleGetReports}
              />
            </Col>
          </Row>
        </div>
        {bookingList.length > 0 && (
          <div className="p-3">
            <table className="table table-bordered fs-12">
              <thead>
                <tr>
                  <th>Select</th>
                  <th>Tx id</th>
                  <th>Tx Date</th>
                  <th>Airline PNR</th>
                  <th>GDS PNR</th>
                  <th>Ticket Numbers</th>
                </tr>
              </thead>
              <tbody>
                {bookingList.map((booking, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={
                          selectedTxList.indexOf(booking.FlightRecord.Txid) > -1
                        }
                        onChange={() =>
                          handleSelection(booking.FlightRecord.Txid)
                        }
                      />
                    </td>
                    <td>{booking.FlightRecord.Txid}</td>
                    <td>{booking.FlightRecord.BookingDate}</td>
                    <td>{booking.FlightRecord.AirlinePnr}</td>
                    <td>{booking.FlightRecord.GdsPnr}</td>
                    <td>{booking.FlightRecord.JDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default BulkInvoiceDownload;
